// import: styles
import { Box } from '@mui/material';
import { ConditionalLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { PUBLIC_CANVAS, STUDIO, TEXT_TO_IMAGE } from 'core/navigation/Routes';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// import: assets
// import: constants
// import: services
// import: utils
// import: redux
// import: components
import AppBar from 'core/layouts/components/app-bar/AppBar';
import {
	appBarHeightPx,
	appBarMobileUIHeightPx,
	reusableStyles,
	tabletBreakpoint,
} from 'core/layouts/ui-blocks/ReusableStyles';
import { layoutStyles } from 'core/layouts/layout/LayoutStyles';

// import: lazy load components

function Layout() {
	const { pathname } = useLocation();
	const isAppBarShown =
		!pathname.includes(STUDIO) &&
		!pathname.includes(TEXT_TO_IMAGE) &&
		!pathname.includes(PUBLIC_CANVAS);
	return (
		<Box id="layout" sx={layoutStyles.page}>
			<ConditionalLayer isShown={isAppBarShown}>
				<Box sx={layoutStyles.fixedHeaderWrapper}>
					<AppBar />
				</Box>
			</ConditionalLayer>
			<Box
				id="marketting-banner-page-wrapper"
				// NOTE: PADDING_TOP CALCULATION
				sx={[
					reusableStyles.pageWrapper,
					{
						paddingTop: isAppBarShown
							? {
									xs: `calc(${appBarMobileUIHeightPx})`,
									[tabletBreakpoint]: `calc(${appBarHeightPx})`,
								}
							: 0,
					},
				]}
			>
				<Outlet />
			</Box>
		</Box>
	);
}

export default Layout;
